<template>
  <MenuPopup>
    <template #menuButton="props">
      <button @click="props.toggleMenu" class="focus:outline-none" v-tooltip="'Menu'">
        <MenuIcon class="text-blue-700 dark:text-dark-text"/>
      </button>
    </template>

    <template #menuBody="props">
      <router-link to="/account" @click="props.toggleMenu"
                   class="flex flex-col px-4 py-2 text-gray-800 hover:bg-gray-100 hover:text-blue-500 border-b border-gray-200 dark:text-gray-100 dark:hover:bg-dark-modal dark:hover:text-blue-200 dark:border-dark-border">
        <div class="font-bold text-lg truncate w-32">{{ username }}</div>
        <div class="flex text-xs text-opacity-30">User Profile</div>
      </router-link>
      <router-link to="/" @click="props.toggleMenu"
                   class="block px-4 py-2 text-gray-800 hover:bg-gray-100 hover:text-blue-500 border-b border-gray-200 dark:text-gray-100 dark:hover:bg-dark-modal dark:hover:text-blue-200 dark:border-dark-border">Rooms
      </router-link>
      <router-link to="#" @click.prevent="logout($event, props.toggleMenu)"
                   class="block px-4 py-2 text-gray-800 hover:bg-gray-100 hover:text-blue-500 dark:text-gray-100 dark:hover:bg-dark-modal dark:hover:text-blue-200 ">Logout
      </router-link>
    </template>
  </MenuPopup>
</template>

<script>
import MenuIcon from "@/assets/menu";
import MenuPopup from "@/components/MenuPopup";
import axios from "@/library/request";
import Storage from "@/library/storage";
import AppStore from "@/store/app";

export default {
  components: {
    MenuIcon,
    MenuPopup
  },
  computed: {
    username() {
      const user = AppStore.session?.user;
      return user?.username?.split(' ')?.[0] || '';
    }
  },
  methods: {
    logout(event, closeMenu) {
      event.preventDefault();
      closeMenu();
      axios.post('/auth/logout')
          .finally(() => {
            AppStore.session = null;
            Storage.remove('USER_SESSION');
            this.$router.replace({path: '/login'});
          })
    }
  },
};
</script>
